<template>
  <!-- 添加或编辑分类 -->
  <el-dialog
    :visible.sync="addprimaryDialog"
    width="25%"
    :title="title"
    class="editBrand"
    @click="onClose"
  >
    <el-form
      :model="queryParams"
      ref="queryParamsRefs"
      :rules="queryParamsRules"
      label-width="100px"
    >
      <el-form-item label="上级分类：" v-if="type!==0&&!state">{{queryParams.label||'--'}}</el-form-item>
      <el-form-item prop="pcName" label="分类名称：">
        <el-input v-model="queryParams.pcName" placeholder="请输入分类名称"></el-input>
      </el-form-item>
      <!-- <el-form-item prop="taxpoint" label="税收数值：" v-if="type===3||(this.typeAddOrEdit === 'add'&&type===2)">
          <el-input v-model="queryParams.taxpoint" placeholder="请输入分类名称"></el-input>
      </el-form-item>-->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">确 定</el-button>
      <el-button @click="onClose">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  productClassAdd,
  productClassUpdateById,
  productClassQueryById
} from '@/api/product/productManage'
import { addOrEditClassRules } from '../utils/formRules'
export default {
  data () {
    return {
      addprimaryDialog: false,
      queryParams: {},
      title: '', // 标题名称
      state: false,
      type: 0,
      typeAddOrEdit: '',
      queryParamsRules: {}
    }
  },
  methods: {
    // type区分添加几级分类type=0添加1级分类,type=1和2添加二级和三级子分类,添加三级分类时才显示税收数值,type=3编辑分类
    // type为一级，二级，三级，||数据全||add/edit
    onInitialize (type, params, typeAddOrEdit) {
      this.queryParams = {
        pcName: '',
        taxpoint: ''
      }
      this.queryParamsRules = addOrEditClassRules
      this.type = type
      this.typeAddOrEdit = typeAddOrEdit
      if (this.typeAddOrEdit === 'add' && this.type === 0) {
        this.title = '添加一级分类'
      } else if (this.typeAddOrEdit === 'add' && (this.type === 1 || this.type === 2)) { // 添加2,3级分类
        this.queryParams = params
        this.title = '添加子分类'
      } else if (this.typeAddOrEdit === 'edit' || this.type === 3) { // 编辑分类需获取分类较全的数据
        productClassQueryById(params.id).then(res => {
          if (res.data.code === 200) {
            if (res.data.obj.classTwo === null) {
              this.state = true
            } else {
              this.state = false
            }
            this.queryParams.pcName = res.data.obj.classType// 一级
            this.queryParams.label = res.data.obj.classTwo// 二级
            this.queryParams.id = res.data.obj.id
            this.queryParams.level = res.data.obj.level
            this.queryParams.taxpoint = res.data.obj.taxpoint
          }
        }).catch(err => {
          console.log(err)
        })
        this.title = '编辑分类'
      }
      this.addprimaryDialog = true
    },
    // 确定
    onSubmit () {
      this.$refs.queryParamsRefs.validate((valid) => {
        if (valid) { // 校验通过
          const params = {
            flag: true,
            pcName: this.queryParams.pcName,
            id: this.queryParams.id
          }
          if (this.type === 0 && this.typeAddOrEdit === 'add') { // 添加一级
            params.pcLevel = 1
            params.pcFid = 0
          } else if (this.type === 1 && this.typeAddOrEdit === 'add') { // 添加二级
            params.pcLevel = 2
            params.pcFid = this.queryParams.id
          } else if (this.type === 2 && this.typeAddOrEdit === 'add') { // 添加三级和税收数值
            params.pcLevel = 3
            params.taxpoint = this.queryParams.taxpoint
            params.pcFid = this.queryParams.id
          } else if (this.typeAddOrEdit === 'edit') { // 编辑分类参数赋值
            params.pcLevel = this.queryParams.level
            params.id = this.queryParams.id
            params.taxpoint = this.queryParams.taxpoint
          }
          if (this.typeAddOrEdit === 'add') {
            productClassAdd(params).then(res => { // 添加分类
              if (res.data.code === 200) {
                this.$message.success('添加成功!')
                this.addprimaryDialog = false
                this.$emit('onRefresh', this.queryParams, this.typeAddOrEdit)
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              console.log(err)
            })
          } else {
            productClassUpdateById(params).then(res => { // 编辑分类
              if (res.data.code === 200) {
                this.$message.success('修改成功!')
                this.addprimaryDialog = false
                this.$emit('onRefresh', this.queryParams, this.typeAddOrEdit)
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              console.log(err)
            })
          }
        } else {
          this.$message.error('校验未通过')
          return false
        }
      })
    },
    // 取消关闭弹窗
    onClose () {
      this.$refs.queryParamsRefs.clearValidate()// 去掉校验
      this.addprimaryDialog = false
    }
  }
}
</script>
